import { AxiosError } from 'axios';
import { StorageData } from './../storage-data';
import { Plan } from '../../api/talent/models/plan.model';


export interface PlanState {
    currentPlan: StorageData<Plan | null, Error | AxiosError | null>;
    prospect: StorageData<boolean | null, Error | AxiosError | null>;
}

export const INITIAL_STATE: PlanState = {
    currentPlan: {
        loading: false,
        data: null,
        error: null
    },
    prospect: {
      loading: false,
      data: false,
      error: null
  }
}

export enum PlanActionTypes {
    GET_CURRENT_PLAN = '@plan/GET_CURRENT_PLAN',
    GET_CURRENT_PLAN_SUCCESS = '@plan/GET_CURRENT_PLAN_SUCCESS',
    GET_CURRENT_PLAN_ERROR = '@plan/GET_CURRENT_PLAN_ERROR',

    SEND_PROSPECT = '@plan/SEND_PROSPECT',
    SEND_PROSPECT_SUCCESS = '@plan/SEND_PROSPECT_SUCCESS',
    SEND_PROSPECT_ERROR = '@plan/SEND_PROSPECT_ERROR',
    SEND_PROSPECT_RESET = '@plan/SEND_PROSPECT_RESET'
}
